import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { isRedirectingToLogin } from "../auth/sessionExpiry";
import { CART_QUERY_KEY, getMyCart } from "../features/Cart/api";
import { useMarketplaceIdentity } from "./useMarketplaceIdentity";

/**
 * Current user's cart from `GET /api/v1/cart/me` (Keycloak-bound; no DB user id).
 */
export function useQueryCart() {
  const { isAuthenticated } = useMarketplaceIdentity();

  const {
    data: cart,
    isError,
    error,
    isLoading,
    isSuccess,
  } = useQuery({
    queryKey: CART_QUERY_KEY,
    queryFn: () => getMyCart(),
    enabled: isAuthenticated,
    retry: false,
  });

  useEffect(() => {
    if (!isError || isRedirectingToLogin()) return;
    const status = error?.response?.status ?? error?.normalizedApiError?.status;
    if (status === 401) return;
    toast.error("An error occurred while fetching cart.");
  }, [isError, error]);

  return {
    cart: cart ?? null,
    isLoading,
    isSuccess,
    isError,
    error,
  };
}
